var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppNavigation'),_c('v-main',{staticStyle:{"padding-top":"0"},attrs:{"transition":"slide-x-transition"}},[_c('router-view')],1),(!_vm.isHome)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }